import { useAppSelector } from "../../hooks/redux.hook";
import { useAppService } from "../../hooks/use-app-service";
import { Community } from "../../types/community/community.type";
import I18 from "../atoms/i18";
import IconButton2 from "../icon-button-2-component";

export default function HelpScoutIcon() {
  const community = useAppSelector((state) => state.community) as Community;
  const communityRole = community?.myRole;

  const { analyticsService } = useAppService();

  // if role is not admin don't show
  if (communityRole !== "admin") {
    return <></>;
  }

  return (
    <div
      onClick={() => {
        // @ts-ignore
        window.Beacon && window.Beacon("open");
        analyticsService.track("support-icon-clicked")
      }}
      className="flex-row flex items-center">
      <IconButton2 icon="life-ring" className="text-xl cursor-pointer" />
      <div className="sm:hidden">
        <I18>Analytics</I18>
      </div>
    </div>
  );
}
